import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ColumnChart from '../../CustomComponent/Charts/ColumnChart';
import SelectDropdown from '../../CustomComponent/Form/SelectDropdown';
import { getClients } from '../../Services/PortfolioService';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getDashboardData } from '../../Services/DashboardService';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import { sortByKey } from '../../Utils';
import { useDashboardData } from '../../Hooks/useDashboardData';
import { H4 } from '../../AbstractElements';

export default function TenantDashboard() {
    const [clients, setClients] = useState<any[]>([]);
    const [selectedClient, setSelectedClient] = useState(localStorage.getItem('selectedClient') ?? '');

    const {
        electricityData,
        gasData,
        waterData,
        electricityGasData,
        totalProperties,
        totalMeters,
        electricityCostData,
        gasCostData,
        waterCostData,
        totalConsumption,
        comparisons,
        peakUsage,
        insights,
        yearlyTrends
    } = useDashboardData(selectedClient, getDashboardData);

    useEffect(() => {
        fetchClients();
    }, []);

    useEffect(() => {
        localStorage.setItem('selectedClient', selectedClient);
    }, [selectedClient]);

    const fetchClients = async () => {
        try {
            const data = await getClients();
            setClients(sortByKey(data, 'name'));
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch clients");
        }
    };

    const clientOptions = clients.map(client => ({
        value: client.client_id,
        label: client.name
    }));

    const electricityTrend = yearlyTrends?.Electricity;
    const gasTrend = yearlyTrends?.Gas;

    return (
        <>
            <Breadcrumbs pageTitle='Dashboard' />
            <Container className='general-widget' fluid>
                <Row className="d-flex justify-content-end">
                    <Col md="4" >
                        <SelectDropdown
                            title={'Clients'}
                            options={clientOptions}
                            value={selectedClient}
                            onOptionSelected={val => setSelectedClient(val as string)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Row className='g-sm-3 height-equal-2 widget-charts'>
                        <Col sm={3}>
                            <Card className="small-widget mb-sm-0">
                                <CardBody className="primary">
                                    <span className="f-12 f-w-900">Total Properties</span>
                                    <div className="d-flex align-items-end gap-1">
                                        <H4 className="font-primary">{totalProperties}</H4>
                                    </div>
                                    <div className="bg-gradient">
                                        <i className={`fa-solid fa-home text-primary`} style={{ fontSize: '1.4em' }} />
                                        {/* <DashboardSvgIcon className="stroke-icon svg-fill" iconId={icon} /> */}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={3}>
                            <Card className="small-widget mb-sm-0">
                                <CardBody className="primary">
                                    <span className="f-12 f-w-900">Total Meters</span>
                                    <div className="d-flex align-items-end gap-1">
                                        <H4 className="font-primary">{totalMeters}</H4>
                                    </div>
                                    <div className="bg-gradient">
                                        <i className={`text-primary server`} style={{ fontSize: '1.4em' }} />
                                        {/* <DashboardSvgIcon className="stroke-icon svg-fill" iconId={icon} /> */}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={3}>
                            <Card className="small-widget mb-sm-0">
                                <CardBody className="primary">
                                    <span className="f-12 f-w-900">Total Electricity Consumption</span>
                                    {/* <span className="f-12 f-w-900">Total Electricity Consumption (2025)</span>
                                    <div className="d-flex align-items-end gap-1">
                                        <H4 className="font-primary">{totalProperties}</H4>
                                    </div>
                                     */}
                                    {/* <div className="d-flex align-items-center gap-2"> */}
                                    <div className='d-flex flex-column align-items-start'>
                                        <H4 className="font-primary">{totalConsumption?.Electricity ?? 0}</H4>

                                        {/* <span className={`f-12 ${comparisons?.Electricity?.percentage_change > 0 ? 'text-danger' : 'text-success'
                                            }`}>
                                            {comparisons?.Electricity?.percentage_change ?? 0}%
                                            {comparisons?.Electricity?.percentage_change > 0 ? ' ↑' : ' ↓'}
                                        </span> */}
                                        <span
                                            className={`f-12 ${electricityTrend?.percentage > 0 ? 'text-danger' : 'text-success'
                                                }`}
                                        >
                                            {electricityTrend?.percentage ?? 0}%
                                            {electricityTrend?.percentage > 0 ? '↑' : '↓'}
                                            <small>vs {electricityTrend?.previousYear}</small>
                                        </span>
                                    </div>
                                    <div className="bg-gradient">
                                        <i className={`fa-solid fa-bolt text-primary`} style={{ fontSize: '1.4em' }} />
                                        {/* <DashboardSvgIcon className="stroke-icon svg-fill" iconId={icon} />  */}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={3}>
                            <Card className="small-widget mb-sm-0">
                                <CardBody className="primary">
                                    <span className="f-12 f-w-900">Total Gas Consumption</span>
                                    {/* <div className="d-flex align-items-center gap-2"> */}
                                    <div className='d-flex flex-column align-items-start'>
                                        <H4 className="font-primary">{totalConsumption?.Gas ?? 0}</H4>

                                        {/* <span className={`f-12 ${comparisons?.Gas?.percentage_change > 0 ? 'text-danger' : 'text-success'
                                            }`}>
                                            {comparisons?.Gas?.percentage_change ?? 0}%
                                            {comparisons?.Gas?.percentage_change > 0 ? ' ↑' : ' ↓'}
                                        </span> */}
                                        <span
                                            className={`f-12 ${gasTrend?.percentage > 0 ? 'text-danger' : 'text-success'
                                                }`}
                                        >
                                            {gasTrend?.percentage ?? 0}%
                                            {gasTrend?.percentage > 0 ? '↑' : '↓'}
                                            <small>vs {gasTrend?.previousYear}</small>
                                        </span>
                                    </div>
                                    <div className="bg-gradient">
                                        <i className={`fa-solid fa-bolt text-primary`} style={{ fontSize: '1.4em' }} />
                                        {/* <DashboardSvgIcon className="stroke-icon svg-fill" iconId={icon} /> */}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Row>
            </Container>
            <Container className='default-dashboard mt-4' fluid>
                <Row className='mt-3'>
                    {electricityData || gasData || waterData || (electricityGasData && gasData) ? (
                        <>
                            {electricityData && <ColumnChart title='Electricity' data={electricityData} height={250} width={290} size={4} />}
                            {gasData && <ColumnChart title='Gas' data={gasData} height={250} width={290} size={4} />}
                            {waterData && <ColumnChart title='Water' data={waterData} height={250} width={290} size={4} />}
                            {electricityGasData && gasData && <ColumnChart title='Electricity-Gas' data={electricityGasData} height={250} width={290} size={4} />}
                        </>
                    ) : (
                        <div style={{ width: '100%', height: '640px', textAlign: 'center' }}>No data available.</div>
                    )}
                </Row>
                <Row>
                    {electricityCostData || gasCostData || waterCostData ? (
                        <>
                            {electricityCostData && <ColumnChart title='Electricity Cost' data={electricityCostData} height={250} width={290} size={4} />}
                            {gasCostData && <ColumnChart title='Gas Cost' data={gasCostData} height={250} width={290} size={4} />}
                            {waterCostData && <ColumnChart title='Water Cost' data={waterCostData} height={250} width={290} size={4} />}
                        </>
                    ) : (
                        ''
                    )}
                </Row>
            </Container>
        </>
    );
}
